import PropTypes from "prop-types";
import { useLoaderData } from "react-router-dom";
import { WebScanApp } from "../components/web-scan-app";

// Route for customers on the "web" platform: render the web-based
// Order-N-Scan app directly instead of launching a native app.
export function WebScanPage(props) {
  const { appName, labId, fileFormats } = props;
  const order = useLoaderData();
  return (
    <WebScanApp
      order={order}
      appName={appName}
      labId={labId}
      fileFormats={fileFormats}
    />
  );
}

WebScanPage.propTypes = {
  appName: PropTypes.string.isRequired,
  labId: PropTypes.string.isRequired,
  fileFormats: PropTypes.arrayOf(PropTypes.string),
};
